// import { on, fetchCart } from '../slater/cart'
import { component } from 'picoapp'
// import Cart from './cart-drawer.js'

export default component(({ node: header, state, actions }) => {
  let isOpen = false
  const toggle = header.querySelector('.js-toggle')
  const cartCount = header.querySelector('.js-cart-count')
  const cartToggles = header.querySelectorAll('.js-cart-drawer-toggle')
  cartCount.innerHTML = state.cart.items.length >= 1 ? state.cart.item_count : 0

  for (let toggle of cartToggles) {
    toggle.addEventListener('click', e => {
      e.preventDefault()
      actions.toggleCart(true)
    })
  }
  function open () {
    header.classList.add('nav-is-open')
    isOpen = true
  }

  function close () {
    header.classList.remove('nav-is-open')
    isOpen = false
  }

  toggle.addEventListener('click', e => {
    isOpen ? close() : open()
  })
  
  let over = false

  window.addEventListener('scroll', e => {
    if (window.scrollY > 1 && !over) {
      over = true
      header.classList.add('is-scrolled')
    } else if (window.scrollY < 1 && over) {
      over = false
      header.classList.remove('is-scrolled')
    }
  })

  return {
    onStateChange (state) {
      cartCount.innerHTML = state.cart.item_count
    }
  }
  //   const cartCount = header.querySelector('.js-cart-count')
  //   const cart = fetchCart()
  //   cart.then(res => {
  //      /* eslint-disable */
  //     res ? cartCount.innerHTML = res.item_count : null
  //     /* eslint-enable */
  //   })
  // on('updated', ({ cart }) => {
  //   cartCount.innerHTML = cart.item_count
  // })
  // on('addon', ({ cart }) => {
  //   cartCount.innerHTML = cart.item_count
  // })
  //   /**
  //  // * Cart opening
  //  // */
  //   const cartToggles = header.querySelectorAll('.js-cart-drawer-toggle')
  //   for (let toggle of cartToggles) {
  //     toggle.addEventListener('click', e => {
  //       console.log('clicked?')
  //       e.preventDefault()
  //       Cart.open()
  //       // const cartDrawer = scripts.cache.get('cart-drawer')
  //       // cartDrawer.open()
  //     })
  //   }
})
